import { Component, Input, OnInit } from '@angular/core';
import { SendDataService } from '../../../../../shared/services/send-data.service';
import { WindowSizeService } from '../../../../../shared/services/window-resize.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../../../../../shared/services/storage.service';
import { PartsListService } from '../../pages/parts-list/parts-list.service';

@Component({
  selector: 'app-line-information',
  templateUrl: './line-information.component.html',
  styleUrls: ['./line-information.component.scss']
})
export class LineInformationComponent implements OnInit {
@Input()  data:any ={}
@Input() formModel:any ={}
  isLargeScreen = window.innerWidth >1199.98;
  count: number = 0;
  todayDate: string = new Date().toLocaleDateString('en-GB', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
  });
  
  constructor(public sendDataService: SendDataService,private windowSizeService: WindowSizeService,
    private toastr: ToastrService,public storageService: StorageService,
    public partsListService: PartsListService,
  ) { }

  ngOnInit(): void {
    this.windowSizeService.getScreenWidth().subscribe((res) => {
      this.isLargeScreen = res >1199.98;
    }); 

  }
  ngOnDestroy(){
  }
}
